__turbopack_context__.v({
  "blok-big-title": "ImageTag-module__l6KrhG__blok-big-title",
  "blok-subtitle": "ImageTag-module__l6KrhG__blok-subtitle",
  "blok-title": "ImageTag-module__l6KrhG__blok-title",
  "bottom-left": "ImageTag-module__l6KrhG__bottom-left",
  "inner": "ImageTag-module__l6KrhG__inner",
  "root": "ImageTag-module__l6KrhG__root",
  "top-left": "ImageTag-module__l6KrhG__top-left",
});
